import { Checkbox as CheckboxPrimitive } from 'radix-ui';
import type { ComponentPropsWithoutRef } from 'react';

import { CheckIcon, Checkbox, Indicator } from './styles';

type RadixCheckboxRootProps = ComponentPropsWithoutRef<
  typeof CheckboxPrimitive.Root
>;
export interface IBaseCheckboxProps extends RadixCheckboxRootProps {
  id?: string;
  dataCy?: string;
}

export const BaseCheckbox = ({
  dataCy = 'checkbox-field',
  ...props
}: IBaseCheckboxProps): JSX.Element => {
  return (
    <Checkbox {...props} data-cy={dataCy}>
      <Indicator>
        <CheckIcon />
      </Indicator>
    </Checkbox>
  );
};
